import * as o from "react";
import n from "react-dom";
import { Primitive as f } from "../../../../../@radix-ui_react-primitive@2.1.3_@types_react-dom@19.2.3_@types_react@19.2.14__@types_re_1181ea5061ec9212248424669240e4ec/bundled_deps/@radix-ui/react-primitive/dist/index.js";
import { useLayoutEffect as u } from "../../../../../@radix-ui_react-use-layout-effect@1.1.1_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-use-layout-effect/dist/index.js";
import { j as c } from "../../../../../../../_virtual/jsx-runtime.js";
var l = "Portal", p = o.forwardRef((r, e) => {
  const { container: a, ...s } = r, [i, m] = o.useState(!1);
  u(() => m(!0), []);
  const t = a || i && globalThis?.document?.body;
  return t ? n.createPortal(/* @__PURE__ */ c.jsx(f.div, { ...s, ref: e }), t) : null;
});
p.displayName = l;
export {
  p as Portal
};
